module.exports = __webpack_public_path__ + "img/03_no.53ad83fb.svg";